import axios, { AxiosPromise } from 'axios';

const ucastnikDownload = (file: string): AxiosPromise<{ redirect: string }> => {
    return axios({
        method: 'GET',
        url: 'Ucastnik/Download/Prepare',
        params: {
            file
        }
    });
};
export default ucastnikDownload;
